"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _buttonControl = _interopRequireDefault(require("../button-control"));

var Credentials = function Credentials(_ref) {
  var credentials = _ref.credentials,
      onClickCopy = _ref.onClickCopy;
  return (0, _preact.h)("section", null, (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    title: "Client ID",
    customInput: (0, _preact.h)("div", {
      className: "cridential-row"
    }, (0, _preact.h)("input", {
      className: "form-control",
      value: credentials.id,
      disabled: true
    }), (0, _preact.h)(_buttonControl.default, {
      newStyle: true,
      size: "medium",
      variant: "brand",
      title: "Copy",
      onClick: function onClick() {
        return onClickCopy('id');
      },
      class: "qa-copy"
    }))
  }), (0, _preact.h)(_InputGroup.default, {
    newStyle: true,
    title: "Client secret",
    formGroupClasses: "last-group",
    customInput: (0, _preact.h)("div", {
      className: "cridential-row"
    }, (0, _preact.h)("input", {
      className: "form-control",
      value: credentials.secret,
      disabled: true
    }), (0, _preact.h)(_buttonControl.default, {
      newStyle: true,
      size: "medium",
      variant: "brand",
      title: "Copy",
      onClick: function onClick() {
        return onClickCopy('secret');
      },
      class: "qa-copy"
    }))
  }));
};

var _default = Credentials;
exports.default = _default;